// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZimR","type":"styles_type__2to1L","choices":"styles_choices__3YgqA"};